/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.TemplateManagementAppService
 */
import * as References from './TemplateManagementAppService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.TemplateManagementAppService#listTemplateInstallsByGlobalId
 */
export const LIST_TEMPLATE_INSTALLS_BY_GLOBAL_ID_QUERY_FIELD_NAME = 'com_hubspot_customassistants_rpc_TemplateManagementAppService_listTemplateInstallsByGlobalId';
export const LIST_TEMPLATE_INSTALLS_BY_GLOBAL_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_TEMPLATE_INSTALLS_BY_GLOBAL_ID_QUERY_FIELD_NAME,
  args: ['templateGlobalId', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.listTemplateInstallsByGlobalIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});